import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@workboard/action-item'
import { PriorityListProps } from '../../../types/sidePanel.types'
import * as SidePanelAction from '../../../actions/sidePanel.actions'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'
import { IconStateWrapper } from './iconWrapper'

const PriorityListComp = (props: PriorityListProps) => {
  const { t } = useTranslation()
  const {
    aiId, columnId, srcVal, values
  } = props
  const [ref] = useOnClickOutside(() => {
    if (typeof props.hideShowListPopup === 'function') {
      props.hideShowListPopup()
    }
  })

  const onPriorityChanges = (item) => {
    if (srcVal == 'act') {
      if (aiId) {
        props.hideShowListPopup()
        props.dispatch(
          SidePanelAction.boardAiPriorityChange(aiId, item.value, columnId)
        )
        $.post(
          `${wbConfig.baseUrl}/activity/updatePriority`,
          { priority: item.value, act_id: aiId }
        )
      }
    } else if (srcVal == 'automation') {
      props.saveTitleAndValue(
        'priorityTitle',
        item.label,
        'priorityVal',
        item.value
      )
    }
  }

  const automationClass = srcVal == 'automation' ? 'automationAttrWidth' : '';

  if (srcVal == 'automation') {
    values.unshift({ value: '', label: t('None') });
  }

  return (
    <div ref={ref} className={`priorityListDivOuterWrap ${automationClass}`}>
      <div className="attrLabel">{t('PRIORITY')}</div>
      {values.map((item: any, index: number) => (
        <div
          key={`priority_${item.value}`}
          className="priorityVal attrValFont clickable"
          data-value={item.value}
          onClick={() => onPriorityChanges(item)}
          style={{ padding: '0px' }}
        >
          <IconStateWrapper isSourceFromAct={(srcVal == 'act')}>
            {
              item?.icons?.component
                ? <Icon name={item?.icons?.component} width="16" height="16" />
                : ''
            }
          </IconStateWrapper>
          <div className="displayInlineB">{item.label}</div>
        </div>
      ))}
    </div>
  )
}

export default PriorityListComp
